"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyClient = void 0;
const axios_1 = __importStar(require("axios"));
require("isomorphic-form-data");
const axios_cache_interceptor_1 = require("axios-cache-interceptor");
const hmac_1 = require("./hmac");
const exceptions_1 = require("./exceptions");
const services_1 = require("./services");
class AirwebTicketLegacyClient {
    constructor(options) {
        this.options = options;
        this.hmac = new hmac_1.AirwebTicketLegacyHmac(this.options.signatureKey, '*', 'SHA-1', 'HEX');
        this.test = new services_1.AirwebTicketLegacyTestService(this);
        this.account = new services_1.AirwebTicketLegacyAccountService(this);
        this.wallet = new services_1.AirwebTicketLegacyWalletService(this);
        this.networks = new services_1.AirwebTicketLegacyNetworksService(this);
        this.orders = new services_1.AirwebTicketLegacyOrderService(this);
        this.tickets = new services_1.AirwebTicketLegacyTicketService(this);
        this.intelligence = new services_1.AirwebTicketLegacyIntelligenceService(this);
        this.media = new services_1.AirwebTicketLegacyMediaService(this);
        this.document = new services_1.AirwebTicketLegacyDocumentService(this);
        this.products = new services_1.AirwebTicketLegacyProductsService(this);
        this.terms = new services_1.AirwebTicketLegacyTermsService(this);
        this.subscriptions = new services_1.AirwebTicketLegacySubscriptionService(this);
        this.payment = new services_1.AirwebTicketLegacyPaymentService(this);
        this.shop = new services_1.AirwebTicketLegacyShopService(this);
        this.action = new services_1.AirwebTicketLegacyActionService(this);
        this.transit = new services_1.AirwebTicketLegacyTransitService(this);
        this.http = axios_1.default.create({ baseURL: options.url });
        if (options.cache) {
            (0, axios_cache_interceptor_1.setupCache)(this.http);
        }
        this.http.interceptors.request.use(this.handleAxiosRequest.bind(this));
        this.http.interceptors.response.use(this.handleAxiosSuccess.bind(this), this.handleAxiosError.bind(this));
    }
    handleAxiosRequest(request) {
        if (request.data) {
            const cleanData = hmac_1.AirwebTicketLegacyHmac.cleanupObject(request.data, [undefined]);
            const sHMAC = this.hmac.generate(cleanData);
            Object.assign(request.data, { sHMAC });
            return request;
        }
        if (request.params) {
            const cleanParams = hmac_1.AirwebTicketLegacyHmac.cleanupObject(request.params, [
                undefined,
                null,
            ]);
            const sHMAC = this.hmac.generate(cleanParams);
            Object.assign(request.params, { sHMAC });
            return request;
        }
        return request;
    }
    handleAxiosSuccess(response) {
        var _a;
        if (!response.data)
            return response;
        if (typeof response.data !== 'object')
            return response;
        if (((_a = response.data.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'Blob')
            return response;
        const legacyResponseStatus = response.data.status;
        let legacyResponseData = response.data.response;
        if (legacyResponseData === null || legacyResponseData === void 0 ? void 0 : legacyResponseData.errorMessage)
            legacyResponseData = {
                error: {
                    message: legacyResponseData === null || legacyResponseData === void 0 ? void 0 : legacyResponseData.errorMessage,
                },
            };
        response.data = legacyResponseData;
        if (legacyResponseStatus == 'ko') {
            throw new axios_1.AxiosError('Request failed with error', 'ERR_RESPONSE_ERROR', response.config, response.request, response);
        }
        if (legacyResponseData === null || legacyResponseData === void 0 ? void 0 : legacyResponseData.error) {
            throw new axios_1.AxiosError('Request failed with error', 'ERR_RESPONSE_ERROR', response.config, response.request, response);
        }
        return response;
    }
    handleAxiosError(error) {
        var _a, _b, _c;
        if (error.code) {
            if (error.code === 'ECONNRESET')
                throw new exceptions_1.AirwebTicketLegacyConnectionException(error.message);
            if (error.code === 'ECONNREFUSED')
                throw new exceptions_1.AirwebTicketLegacyConnectionException(error.message);
            if (error.code === 'ECONNABORTED' && error.message.includes('timeout'))
                throw new exceptions_1.AirwebTicketLegacyTimeoutException(error.message);
        }
        const data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
        if (data === null || data === void 0 ? void 0 : data.error) {
            error.response = Object.assign(Object.assign({}, error === null || error === void 0 ? void 0 : error.response), { data: data.error });
            throw {
                response: error.response,
                request: error.request,
                config: error.config,
                code: (_c = (_b = data === null || data === void 0 ? void 0 : data.error) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : null,
                isAxiosError: true,
            };
        }
        throw error;
    }
}
exports.AirwebTicketLegacyClient = AirwebTicketLegacyClient;
//# sourceMappingURL=client.js.map